import React, { useEffect, useRef } from 'react';
import { createUseStyles } from 'react-jss';
import { Trans } from 'react-i18next';
import { Theme } from '@app/theme';
import { PublicBackgroundBlock } from '@app/core';

const useStyles = createUseStyles((theme: Theme) => ({
  title: {
    ...theme.fonts.h3,
    margin: 0,
    marginBottom: theme.marginBase,
  },
}));

export interface SetupSectionProps {
  title?: string;
  children: React.ReactNode;
  hidden?: boolean;
}

export const InstructionSection = ({
  title,
  children,
  hidden,
}: SetupSectionProps) => {
  const classes = useStyles();

  const sectionRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!hidden) {
      const ref = sectionRef.current;
      if (ref) {
        setTimeout(() => {
          ref.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }, 100);
      }
    }
  }, [hidden]);

  if (hidden) {
    return null;
  }

  return (
    <div ref={sectionRef}>
      <PublicBackgroundBlock>
        {title && (
          <h1 className={classes.title}>{title}</h1>
        )}
        {children}
      </PublicBackgroundBlock>
    </div>
  );
};
